import { fetcher } from 'services/helpers/responseHandler'

const stats = async ({ subsidiaryIds, fromDate, toDate }, abortController) =>
  fetcher.post(
    'engagement/consumer',
    {
      subsidiaryIds,
      fromDate,
      toDate
    },
    abortController
  )

const agents = async ({ subsidiaryIds, fromDate, toDate }, abortController) =>
  fetcher.post('engagement/agents', { subsidiaryIds, fromDate, toDate }, abortController)

const agentDetails = async ({ subsidiaryIds, fromDate, toDate }, abortController) =>
  fetcher.post(
    'engagement/agents/details',
    { subsidiaryIds, fromDate, toDate },
    abortController
  )

const consumerDetails = async ({ subsidiaryIds, fromDate, toDate }, abortController) =>
  fetcher.post(
    'engagement/consumer/details',
    { subsidiaryIds, fromDate, toDate },
    abortController
  )

const topics = async ({ subsidiaryIds, fromDate, toDate }, abortController) =>
  fetcher.post('engagement/topics', { subsidiaryIds, fromDate, toDate }, abortController)

const topicDetails = async ({ subsidiaryIds, fromDate, toDate }, abortController) =>
  fetcher.post(
    'engagement/topics/details',
    { subsidiaryIds, fromDate, toDate },
    abortController
  )

const kinds = async ({ subsidiaryIds, fromDate, toDate }, abortController) =>
  fetcher.post('engagement/kinds', { subsidiaryIds, fromDate, toDate }, abortController)

const engagementApi = {
  stats,
  agents,
  agentDetails,
  consumerDetails,
  topics,
  topicDetails,
  kinds
}

export default engagementApi
